import { OptionProps } from 'components/Common/Form/Select';

export enum Types {
	CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE = '@SGU/CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE',
	CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE_SUCCESS = '@SGU/CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE_SUCCESS',
	CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE_FAILURE = '@SGU/CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE_FAILURE',
	CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE_CLEAR = '@SGU/CONSULTAR_PARAMETRO_LOCALIDADE_DETALHE_CLEAR',
}

export interface ConsultarParametroLocalidadeDetalhe {
	status: number;
	data: ParametroLocalidade | null;
	enum: OptionProps[];
	totalRegistrosConsulta: number;
}

export interface ParametroLocalidade {
	siglaParametro: string;
	descricaoParametro: string;
	localidades: LocalidadesAssociada[];
}

export interface ConsultarParametroLocalidadeDetalheRequest {
	sigla: string;
	idOrgao?: number;
}

export interface LocalidadesAssociada {
	idLocalidade: number | string;
	nomeLocalidade: string;
	idParametro: number | string;
	valorParametro: string;
	valor: string;
	key?: string;
}
